<template>
  <div class="voucherInvalid">
    <div class="subHead">
      <van-icon name="arrow-left" class="arrow" @click="goBack" />
      <span class="subHead-text">历史卡券</span>
    </div>
    <div v-if="couponsList.length === 0">
      <van-empty description="暂无可用卡券" />
    </div>
    <div v-else>
      <van-list
          v-model="loading"
          :offset="300"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
      >
        <div v-for="item in couponsList" :key="item.id" class="listItem">
          <div class="top">
            <div class="right">
              <div class="name">{{ item.couponName }}</div>
              <div class="time">
                <van-tag type="primary">
<!--                  {{ item.consumeTypeName }}-->
                  {{ item.consumeType === 'COST_PER_TIMES' ? '次数抵扣券' : '' }}
                </van-tag>
                <van-tag type="success" style="margin-left: 10px">
                  {{ item.usingStart }} ~ {{ item.usingEnd }}
                </van-tag>
              </div>
            </div>
            <div class="left">
              <svg-icon :icon-class="item.couponStatus === 'COUPON_USED' ? 'used' : 'expired'" style="font-size: 0.45rem" />
              <span class="times">
              {{ item.deductionTimes || item.deductionFee }}{{ item.consumeType === 'COST_PER_TIMES' ? '次' : '元' }}
            </span>
            </div>
          </div>
          <div class="down">
            <div class="close">
              <div class="rule" v-if="item.expireDate">{{ item.createTime }}~{{ item.expireDate }}</div>
              <div class="rule" v-else>长期有效</div>
              <div>{{ item.couponSerial }}</div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import { myCoupons } from '@/api/user';
export default {
  name: 'VouchersList',
  data() {
    return {
      page: 1,
      size: 10,
      total: 0,
      remindChecked: false,
      text: '',
      loading: false,
      showRule: false,
      couponsList: []
    };
  },
  computed: {
    maxPage() {
      return Math.ceil(this.total / this.size);
    },
    finished() {
      return this.page > this.maxPage;
    }
  },
  watch: {
    couponsList: {
      handler(nv) {
        this.loading = false;
      },
      immediate: true
    }
  },
  activated() {
    if (this.page !== 1 || this.couponsList.length) {
      this.page = 1;
      this.couponsList = [];
      this.getList(this.activeName);
    }
  },
  created() {
    this.getList();
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'vouchers' });
    },
    getList() {
      const data = {
        // queryType: 'ACTIVE',
        queryType: 'HISTORY',
        page: this.page,
        size: this.size
      };
      myCoupons(data).then(res => {
        this.couponsList.push(...res.data.list);
        this.total = res.data.totals;
      });
    },
    onLoad() {
      if (this.page > this.maxPage) {
        return;
      } else {
        ++this.page;
      }
      this.getList();
    },
    getCoupons() { // 获取卡券
      this.$router.push({ name: 'couponList' });
    }
  }
};
</script>

<style lang="less">
.change_val(@name, @px){
@{name}: @px / 200.6 * 1rem;
}
.change_margin(@name, @top, @right){
@{name}: @top / 200.6 * 1rem @right / 200.6 * 1rem;
}

.voucherInvalid {
  .listItem {
    background: #FFFFFF;
    border: 1px solid #EFEFF4;
    box-shadow: 0px 3px 6px rgba(51, 51, 51, 0.1);
    opacity: 1;
    border-radius: 6px;
    .change_val(margin, 16);

    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid rgba(0, 0, 0, 0.15294117647058825);
      opacity: 1;
      .change_margin(padding, 22, 38);
      .right {
        .name {
          .change_val(font-size, 32);
        }

        .time {
          line-height: 33px;
          color: rgba(51, 51, 51, 0.7);
          opacity: 1;
          .change_val(margin-top, 18);
          .change_val(font-size, 24);
          .change_val(line-height, 33);
        }
      }
      .left {
        display: flex;
        align-items: center;
        color: rgba(0, 0, 0, 0.5);
        .change_val(font-size, 42);

        .times {
          margin-left: 0.1rem;
        }
      }
    }

    .down {
      display: flex;
      flex-direction: column;
      color: rgba(51, 51, 51, 0.7);
      .change_margin(padding, 19, 38);
      .close {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .rule {
          display: flex;
          align-items: center;
          .arrow {
            margin-left: 0.04rem;
          }
        }
      }
      .open {
        .change_val(margin-top, 16);

        .item {
          color: rgba(51, 51, 51, 0.7);
          .change_val(font-size, 20);
          .change_val(line-height, 33);
        }
      }
    }
  }
}

</style>
